export default __webpack_public_path__ + "static/media/dimg2.6256f250.jpg";